export const colours = {
  background: "#004F57",
  backgroundLight: "#00636C",
  primary: "#FF9A9A",
}

export const weights = {
  regular: "400",
  bold: "700",
}

export const fontFamily = {
  roboto: "'Roboto Condensed', sans-serif",
}
